// Verify magic-link landing (VII-207).
// User clicks the link in their email → arrives here with ?token=… → POST verify → bearer stored → redirect.

import React, { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import portalApi from '../api';
import { setPortalBearer } from '../auth';

export default function AuthVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const exchanged = useRef(false);

  useEffect(() => {
    // React strict-mode fires effects twice in dev; the magic link is
    // single-use, so we guard against the second call consuming it.
    if (exchanged.current) return;
    exchanged.current = true;

    const token = params.get('token');
    if (!token) {
      setError('Missing token in URL.');
      return;
    }
    (async () => {
      try {
        const res = await portalApi.post('/portal/auth/verify', { token });
        setPortalBearer(res.data.bearer, res.data.email);
        navigate('/portal/tickets', { replace: true });
      } catch (err) {
        setError(err?.response?.data?.detail || 'Could not verify the sign-in link.');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 2, p: 2 }}>
      {error ? (
        <>
          <Alert severity="error">{error}</Alert>
          <Button variant="outlined" onClick={() => navigate('/portal/login', { replace: true })}>
            Back to sign-in
          </Button>
        </>
      ) : (
        <>
          <CircularProgress />
          <Typography color="text.secondary">Signing you in…</Typography>
        </>
      )}
    </Box>
  );
}
